import { throwTranslatableError } from '@/core';
import { updateSubOrderRequest } from '../../requests';
import deepCopy from 'deepcopy';
import rdbClient from 'rdb-client';

export default async function insertSubOrderBefore({ dispatch }, { subOrder, despatchParty }) {
	if (!subOrder) {
		throw new Error('failedToAddSubOrderBefore');
	}
	let subOrderClone = deepCopy(subOrder);
	subOrder.despatchParty = despatchParty;
	subOrder.despatchOption = 'custom';

	try {
		let patches = rdbClient.createPatch(subOrderClone, subOrder);
		await updateSubOrderRequest(subOrder.id, { id: subOrder.id, patches });
		dispatch('autoRefreshOrder');
	} catch (e) {
		throwTranslatableError(e, 'failedToAddSubOrderBefore');
	}
}